module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar image = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};\n%>\n<div>\n<% if (image.url) { %><div class=\"image\" style=\"background-image:url(<%=image.url; %>)\"></div><% } %>\n<div class=\"data\">\n<div class=\"title\"><%= model.teaserTitle || model.title %></div>\n<div class=\"desc\"><%= model.teaserIntro || model.intro %></div>\n<div class=\"info\">\n<% if (model.date) { %><div class=\"date\"><div><img src=\"/icons/calendar.svg\" width=\"16\" height=\"18\" alt=\"Icon Datum\"></div><%=model.date;%></div><% } %>\n<% if (model.pdfLink) { %><div class=\"file\"><div><img src=\"/icons/pdf.svg\" width=\"15\" height=\"20\" alt=\"Icon PDF\"></div><a href=\"<%=model.pdfLink;%>\" onclick=\"event.stopPropagation();\" target=\"_blank\">Download PDF</a></div><% } %>\n</div>\n</div>\n</div>"
  , __filename = "components/templates/news/list/teaser.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var image = (helpers.detectRenderedImage(model.image, model._image) || {}).rendered || {};

    ; __line = 3
    ; __append("\n<div>\n")
    ; __line = 5
    ;  if (image.url) { 
    ; __append("<div class=\"image\" style=\"background-image:url(")
    ; __append(escapeFn(image.url ))
    ; __append(")\"></div>")
    ;  } 
    ; __append("\n<div class=\"data\">\n<div class=\"title\">")
    ; __line = 7
    ; __append(escapeFn( model.teaserTitle || model.title ))
    ; __append("</div>\n<div class=\"desc\">")
    ; __line = 8
    ; __append(escapeFn( model.teaserIntro || model.intro ))
    ; __append("</div>\n<div class=\"info\">\n")
    ; __line = 10
    ;  if (model.date) { 
    ; __append("<div class=\"date\"><div><img src=\"/icons/calendar.svg\" width=\"16\" height=\"18\" alt=\"Icon Datum\"></div>")
    ; __append(escapeFn(model.date))
    ; __append("</div>")
    ;  } 
    ; __append("\n")
    ; __line = 11
    ;  if (model.pdfLink) { 
    ; __append("<div class=\"file\"><div><img src=\"/icons/pdf.svg\" width=\"15\" height=\"20\" alt=\"Icon PDF\"></div><a href=\"")
    ; __append(escapeFn(model.pdfLink))
    ; __append("\" onclick=\"event.stopPropagation();\" target=\"_blank\">Download PDF</a></div>")
    ;  } 
    ; __append("\n</div>\n</div>\n</div>")
    ; __line = 14
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/news/list/teaser.ejs

}